<template>
  <button type="button" :disabled="disabled || loading"
    class="inline-flex items-center whitespace-nowrap px-4 py-2 ml-2 font-medium text-white border rounded-md shadow-sm bg-primary-600 border-primary-400 hover:bg-primary-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:bg-gray-300">
    <span class="inline-flex items-center">
      <svg v-if="loading" class="w-4 h-4 mr-2 animate-spin flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24" aria-hidden="true">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
        <path class="opacity-75" fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
      </svg>

      <span v-if="loading && loadingText" class="text-sm">{{ loadingText }}</span>

      <span v-else class="text-sm">
        <slot />
      </span>
    </span>
  </button>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    loading: Boolean,
    loadingText: String,
  },
};
</script>

<style></style>